<template>
    <div class="">

        <div v-if="this.iframeIsLoading" class="d-flex justify-content-center mt-5 mb-1">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div v-if="this.maxRetryReached" class="d-flex justify-content-center mt-5 mb-1">
            <h4>Maximum retries reached, skipping to next step.</h4>
        </div>

        <iframe class="flinksconnect" :height="this.iframeHeight" :style="this.iframeStyle" loading="lazy" :src="this.iframeString"></iframe>

    </div>
</template>
<script>

import { inject } from 'vue';
import { formFunctions } from '@/form/helpers/functions.js';

export default {
    name: "FlinksiFrame",
    emits: ["update:model-value", "input"],
    setup(props) {
        const { app, updateApplicationField } = inject('app'); // app is being provided in Application.vue
        return {
            app,
            updateApplicationField
        }
    },
    components: {
    },
    // props: ["minlength","maxlength","type","placeholder","value","name","label", "addressProp"],
    props: {
        minlength: {},
        maxlength: {},
        type: {},
        placeholder: {},
        value: {},
        name: {},
        label: {},
        addressProp: {
            type: Object,
            required: false,
            default: null,
        },
        productName: {
            type: String,
            required: false,
            default: 'personal_loan',
        }
    },
    data: (props) => {
        let isTestFlow = false;
        let isTestIframe = false;

        let iframeIsLoading = false;
        let maxRetryReached = false;

        let daysOfTransactions = 90; // Days90, Days365

        let province = props.addressProp.province ?? null;
        // if personal_loan in QC then daysOfTransactions = 365
        if(province && province == 'QC' && props.productName == 'personal_loan') {
            daysOfTransactions = 365;
        }

        return {
            isTestFlow,
            isTestIframe,
            iframeIsLoading,
            maxRetryReached,
            daysOfTransactions
        };
    },
    async mounted() {
        // event listeners
        window.addEventListener("message", this.messageEvent, false);
        this.iframeIsLoading = true;
        if(this.shouldSkipFlinks || await this.checkIfFlinksExists()) {
            this.$emit('goToNextStep');
        }
    },
    computed: {
        iframeString() {
            return `https://loanscanada-iframe.private.fin.ag/v2/?demo=${this.showDemoIframe}&termsUrl=https%3A%2F%2Floanscanada.ca%2Fterms%2F&terms&NoCheckbox=true&termsTextLink=Terms+and+Conditions&termsTextPreLink=By+choosing+to+continue%2C+you+agree+to+the&termsTextPostLink=and+authorize+the+communication+of+your+financial+information+to+Loans+Canada and its lender partners.&customerName=Loans+Canada&accountSelectorEnable=true&accountSelectorCurrency=cad&maximumRetry=3&daysOfTransactions=Days${this.daysOfTransactions}`
        },
        iframeHeight() {
            return this.iframeIsLoading ? '0' : '760';
        },
        iframeWidth() {
            return '';
        },
        iframeStyle() {
            return this.iframeIsLoading ? '' : 'width:100%';
        },
        shouldSkipFlinks() {
            return ( this.isTestFlow || (this.app && this.app.flinks_demo && this.app.flinks_demo == '1') ) ? false :
            (
                !this.app ||
                (this.app.flinks_skip && this.app.flinks_skip == '1') ||
                !this.app.unique_id ||
                !this.appMeetsConditions
            );
        },
        showDemoIframe() {
            return this.isTestIframe || (this.app && this.app.flinks_demo && this.app.flinks_demo == '1');
        },
        appMeetsConditions() {
            let appProductName = this.app.product_name;
            let passedFiltersBasedInProduct = false;
            let passedPartnerCriteria = false;
            let passedGeneralFilters = this.app.address
                && this.app.address.province
                && this.app.income_type
                && this.app.monthly_income;

            if(passedGeneralFilters) {
                switch(appProductName) {
                    case 'car_loan':
                    case 'powersports':
                        passedFiltersBasedInProduct = true;
                        break;
                    default:
                    case 'personal_loan':
                        passedFiltersBasedInProduct = this.app.direct_deposit
                            && this.app.direct_deposit == 'yes';
                        break;
                }
            }

            if(passedGeneralFilters && passedFiltersBasedInProduct) {
                passedPartnerCriteria = this.appMeetPartnerCriteria('prpl')
                    || this.appMeetPartnerCriteria('skcp')
                    || this.appMeetPartnerCriteria('gl')
                    || this.appMeetPartnerCriteria('lnie');
            }

            return passedGeneralFilters && passedFiltersBasedInProduct && passedPartnerCriteria;
        },
    },
    methods: {
        async checkIfFlinksExists() {
            if(!this.app || !this.app.unique_id) {
                return false;
            }

            let payload = {
                uid : this.app.unique_id
            };

            let response = await formFunctions.apiHasFlinks(payload);
            if (response?.status == "success" && response?.has_flinks_log) {
                return true;
            }
            return false;
        },
        async messageEvent(e) {
            // event from iframe
            //     {step: 'INSTITUTION_SELECTED', institution: 'FlinksCapital'}
            // event from iframe
            //     {step: 'COMPONENT_LOAD_CREDENTIAL', institution: 'FlinksCapital'}
            // event from iframe
            //     {step: 'COMPONENT_ACCEPT_TERMS', institution: 'FlinksCapital'}
            // event from iframe
            //     {step: 'SUBMIT_CREDENTIAL', institution: 'FlinksCapital'}
            // event from iframe
            //     {requestId: 'c42404c5-a6c5-442a-a770-185c16c32356', flinksCode: 'QUESTION_NOT_FOUND', mfaTypes: Array(1), institution: 'FlinksCapital'}
            // event from iframe
            //     {step: 'COMPONENT_LOAD_MFA', mfaTypes: Array(1), institution: 'FlinksCapital'}
            // event from iframe
            //     {step: 'SUBMIT_MFA', institution: 'FlinksCapital'}
            // event from iframe
            //     {requestId: 'c42404c5-a6c5-442a-a770-185c16c32356', loginId: '0aec64b3-7153-4b17-2c6d-08db44c451a8', institution: 'FlinksCapital'}
            // event from iframe
            //     {step: 'COMPONENT_LOAD_ACCOUNT_SELECTION', totalAccounts: 6, displayedAccounts: 1, institution: 'FlinksCapital'}
            // event from iframe
            //     {step: 'ACCOUNT_SELECTED', accountId: 'bf656a60-908f-40af-8118-973dde0a5c19', institution: 'FlinksCapital'}
            // event from iframe
            //     {step: 'REDIRECT', url: 'https://loanscanada-iframe.private.fin.ag/v2/Resul…-40af-8118-973dde0a5c19&institution=FlinksCapital', loginId: '0aec64b3-7153-4b17-2c6d-08db44c451a8', requestId: 'c42404c5-a6c5-442a-a770-185c16c32356', accountId: 'bf656a60-908f-40af-8118-973dde0a5c19', …}

            // accountId:
                // "bf656a60-908f-40af-8118-973dde0a5c19"
            // institution:
                // "FlinksCapital"
            // loginId:
                // "0aec64b3-7153-4b17-2c6d-08db44c451a8"
            // requestId:
                // "c42404c5-a6c5-442a-a770-185c16c32356"
            // step:
                // "REDIRECT"
            // url:
                // "https://loanscanada-iframe.private.fin.ag/v2/Result/FlinksCapital?thank-you=true&demo=true&loginId=0aec64b3-7153-4b17-2c6d-08db44c451a8&accountId=bf656a60-908f-40af-8118-973dde0a5c19&institution=FlinksCapital"


            if( e && e.data && e.data.step ) {
                console.log('event from iframe starts');

                switch(e.data.step) {
                    case "APP_MOUNTED":
                        console.log('APP_MOUNTED');
                        this.iframeIsLoading = false;
                        break;
                    case "REDIRECT" :
						console.log('REDIRECT');
						// console.log(e.data);

						if(typeof e.data.loginId !== "undefined") {

                            this.updateApplicationField('completed_flinks', 'yes');

                            let payload = {
                                flinksLoginId : e.data.loginId,
                                uid : this.app.unique_id
                            };

                            let response = await formFunctions.apiStoreFlinks(payload);

                            if( typeof response.status !== "undefined" ) {
                                if(response.status == "success") {
                                    console.log("login id stored");
                                } else {
                                    console.log("check flinks controller for error");
                                }
                            } else {
                                console.log("check flinks controller for error");
                            }
                        }

                        this.nextStepAfterSeconds(2);

					break;
					case "MAXIMUM_RETRY_REACHED" :
						// this is based on iFrame parameter and is set by us
						console.log('skip flinks');
                        this.maxRetryReached = true;
						this.nextStepAfterSeconds(3);
					break;
                    default:
                        // console.log(e.data);
                        break;
                }

            }
            else {
                console.log('event from iframe finishes');
            }

        },
        nextStepAfterSeconds(seconds = 2) {
            setTimeout(() => this.$emit('goToNextStep'), (seconds*1000));
        },
        appMeetPartnerCriteria(partner = null) {
            switch(partner) {

                case 'prpl':
                    var allowedProvinces = ['AB','BC','ON','SK','NB','NL','NS'];
                    var allowedIncomeType = ['full_time','part_time'];
                    var allowedCreditSituations = ['good','fair','unknown'];

                    return true &&
                        allowedProvinces.includes(this.app.address.province) &&
                        allowedIncomeType.includes(this.app.income_type) &&
                        // we removed credit score question for now
                        // this.app.credit_score && this.app.credit_score != 'low' &&
                        this.app.in_credit_situation && allowedCreditSituations.includes(this.app.in_credit_situation);

                    break;

                case 'skcp':
                    var allowedProvinces = ["AB","BC","MB","NB","NL","ON","PE","SK","NT","NU","YK"];
                    var allowedIncomeType = ['full_time','retired'];
                    var allowedCreditSituations = ['good','fair','unknown'];

                    return true &&
                        allowedProvinces.includes(this.app.address.province) &&
                        allowedIncomeType.includes(this.app.income_type) &&
                        // we removed credit score question for now
                        // this.app.credit_score && this.app.credit_score != 'low' &&
                        this.app.in_credit_situation && allowedCreditSituations.includes(this.app.in_credit_situation);

                    break;

                case 'gl':
                    var allowedProvinces = ["AB","BC","NB","PE","ON","NL"]; //QC removed on June-27-2025 by Cris
                    var allowedIncomeType = ["full_time","part_time","gig_worker","self_employed"];
                    var totalIncome = (this.app.monthly_income ?? 0) + (this.app.monthly_other_income ?? 0);
                    var requestedAmount = this.app.requested_amount ?? 0;

                    return true &&
                        allowedProvinces.includes(this.app.address.province) &&
                        allowedIncomeType.includes(this.app.income_type) &&
                        totalIncome >= 2000 &&
                        requestedAmount <= 7500;
                    break;

                case 'lnie':
                    var allowedProvinces = ["AB","BC","MB","NB","NL","NS","ON","PE","SK","NT","NU","YK"];
                    var allowedIncomeType = ['full_time','part_time','temp_contract','gig_worker','self_employed'];
                    var requestedAmount = this.app.requested_amount ?? 0;

                    return true &&
                        allowedProvinces.includes(this.app.address.province) &&
                        allowedIncomeType.includes(this.app.income_type) &&
                        requestedAmount <= 3500;
                    break;

                default:
                    return true;
            }
        }
    },
}
</script>


<style scoped>
</style>
